import { makeGetters } from '@/utils/vuex-helper';

const state = {
  isDashboardMenuVisible: true,
  isScheduleMenuVisible: true,
  isTimetableMenuVisible: true,
  isAnalyticsMenuVisible: true,
  isLockerMenuVisible: true,
  isRegisteredMemberMenuVisible: true,
  isPendingMemberMenuVisible: true,
  isCreateMemberMenuVisible: true,
  isNoticeMenuVisible: true,
  isCreateWodButtonVisible: true,
  isSettingMenuVisible: true
};

const mutations = {
  setAccountAccessAuth(state, { isOwnerAccount, accessAuth }) {
    if (isOwnerAccount) {
      return;
    } else {
      const {
        handle_dashboard,
        handle_schedule,
        handle_timetable,
        handle_analytics,
        handle_locker,
        handle_registered_member,
        handle_pending_member,
        handle_create_member,
        handle_notice,
        handle_wod,
        handle_setting
      } = accessAuth;
      // set value
      state.isDashboardMenuVisible = handle_dashboard;
      state.isScheduleMenuVisible = handle_schedule;
      state.isTimetableMenuVisible = handle_timetable;
      state.isAnalyticsMenuVisible = handle_analytics;
      state.isLockerMenuVisible = handle_locker;
      state.isRegisteredMemberMenuVisible = handle_registered_member;
      state.isPendingMemberMenuVisible = handle_pending_member;
      state.isCreateMemberMenuVisible = handle_create_member;
      state.isNoticeMenuVisible = handle_notice;
      state.isCreateWodButtonVisible = handle_wod;
      state.isSettingMenuVisible = handle_setting;
    }
  }
};

const getters = {
  ...makeGetters([
    'isDashboardMenuVisible',
    'isScheduleMenuVisible',
    'isTimetableMenuVisible',
    'isAnalyticsMenuVisible',
    'isLockerMenuVisible',
    'isRegisteredMemberMenuVisible',
    'isPendingMemberMenuVisible',
    'isCreateMemberMenuVisible',
    'isNoticeMenuVisible',
    'isCreateWodButtonVisible',
    'isSettingMenuVisible'
  ])
};

const actions = {
  syncAccountAccessAuth({ commit, getters }) {
    const setState = {
      isOwnerAccount: getters.getIsOwnerAccount,
      accessAuth: getters.getInstructorAccessAuth
    };
    commit('setAccountAccessAuth', setState);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
